import { render, staticRenderFns } from "./IngredientsSummary.vue?vue&type=template&id=3fb0143e&scoped=true&"
import script from "./IngredientsSummary.vue?vue&type=script&lang=js&"
export * from "./IngredientsSummary.vue?vue&type=script&lang=js&"
import style0 from "./IngredientsSummary.vue?vue&type=style&index=0&id=3fb0143e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb0143e",
  null
  
)

export default component.exports